export default __webpack_public_path__ + "static/media/holamundo.bb179567.JPG";